<template>
  <div>
    <div class="wrong"
         :class="{'js-wrong-answer':  question.question.correct_answer !== question.answer}"
         v-for="question of answeredQuestions"
         v-if="isAnswerShown(question)"
         :key="question.index"
    >
      <div class="wrong-header">
        <div class="wrong-number">Вопрос {{ question.index }}</div>
        <div class="wrong-question" v-html="question.question.text"></div>
        <div class="wrong-btn js-wrong-btn" data-open="close">Показать</div>
      </div>

      <img v-if="question.question.image" :src="`${$APP_URL}/storage/${question.question.image}`" class="wrong-img"/>

      <div class="wrong-block">
        <div class="answer"
             v-for="(answer, key, index) in question.answers"
             :key="index"
             :class="{ 'answer-right': question.question.correct_answer === key, 'answer-wrong': key === question.answer }"
        >
          <div class="answer-header">
            <div class="answer-number">{{ index + 1 }}</div>
            <div class="answer-title">{{ answer }}</div>
          </div>

          <div class="answer-info" v-if="question.question.correct_answer === key">
            <hr>
            <div class="text" v-html="question.question.comment"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mainMixin from '@/mixins/tests/main';

  export default {
    name: 'Answers',
    props: {
      answeredQuestions: {
        type: Array,
        required: true,
      },
      showType: {
        type: String,
        default: 'all',
      },
    },
    mixins: [mainMixin],
    mounted() {
      this.initResultDropdowns();
      this.toggleWrongDropdowns();
    },
    methods: {
      isAnswerShown(question) {
        if (this.showType === 'all') return true;
        return question.answer !== question.question.correct_answer;
      },
    },
  };
</script>
